module.exports = __webpack_public_path__ + "static/kokorokara-0f73f709b5c2fc2c5f89282d081fcddc.png";